module.exports =  {

  whyTokenNotFound: {
    title: 'Why I Can\'t Find the Token I\'m Interested in When I Create a New Order?',
    contents: `
    	<p>When you create a new order, you can select tokens for buying and selling from the dropdown menu.
      The available tokens listed in the menus include your tracked tokens as well as some popular tokens.
      If you can't find the token you are interested there, you can go back to "My Tokens" page to add that
      token first. If you want to create sell order for that token, you will also need to add token allowance
      for that token first.</p>
      <p>At LedgerDex, we allow trading pairs between any ERC20 tokens. You can add new trading pairs
      by yourself withou asking our permissions.</p>
    `,
  },

  whyTokenNotSelectableForSelling: {
    title: 'Why I Can\'t Select Some Tokens to Sell When I Create a New Order?',
    contents: `
    	<p>When you select a token to sell, on the token selection dropdown menu, only those tokens that you have
    	a non-zero balance and have already set allowance can be selected for selling.</p>
    `,
  },

}

